import { render, staticRenderFns } from "./VoipUI.vue?vue&type=template&id=4676f76a"
import script from "./VoipUI.vue?vue&type=script&lang=js"
export * from "./VoipUI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports